var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-card-title',[_vm._v(" Link pratica non più valido ")])],1),_c('v-card-text',{staticClass:"subtitle-1"},[_vm._v(" Il link per accedere alla pratica non è più valido. "),_c('br')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }